export var DocumentRequestStatus;
(function (DocumentRequestStatus) {
    DocumentRequestStatus["RAFT_STATUS"] = "0";
    DocumentRequestStatus["IN_PROGRESS_STATUS"] = "1";
    DocumentRequestStatus["COMPLETED_STATUS"] = "2";
    DocumentRequestStatus["CANCELED_STATUS"] = "3";
})(DocumentRequestStatus || (DocumentRequestStatus = {}));
